import React, { useState } from "react";
import Input from "../../Components/Input/Input";
import { encryptor, getPayloadHash } from "../../services/helper";
import { postFormDataCall } from "../../services/apiCall";
import { makeErrorToast, makeToast } from "../../Components/Toast/Toast";
import { useNavigate } from "react-router-dom";
import { setLocalToken } from "../../services/token";

const SignIn = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ phone: "", password: "" });
  const [error, setError] = useState({ phone: "", password: "" });

  const isValidData = () => {
    let isValid = true;

    if (!data?.phone) {
      isValid = false;
      setError((prev) => ({ ...prev, phone: "Enter your phone" }));
    } else {
      if (data.phone.length !== 10) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          phone: "Enter a valid 10 digit phone number",
        }));
      }
    }

    if (!data?.password) {
      isValid = false;
      setError((prev) => ({ ...prev, password: "Enter your password" }));
    }

    return isValid;
  };

  const submitHandler = async (e) => {
    try {
      e.preventDefault();
      if (!isValidData()) {
        return null;
      }

      let payload = {
        phone: data.phone,
        password: data.password,
      };

      const dataToSend = getPayloadHash({ data: payload });
      let response = await postFormDataCall("/login", {}, { data: dataToSend });
      if (response.success) {
        const encryptedData = encryptor({ payload: response?.JOBS_APP });
        setLocalToken(encryptedData);
        if (response?.JOBS_APP?.usertype === "User") {
          navigate("/user");
        } else if (response?.JOBS_APP?.usertype === "Company") {
          navigate("/company");
        }
      } else {
        if ("verified" in response && !response?.verified) {
          makeToast({
            message:
              "Please verify your account. OTP has been sent to you WhatsApp.",
          });
          const raw = {
            user_id: response?.user_id,
            phone: data.phone,
          };
          const encryptedData = encryptor({ payload: raw });
          setLocalToken(encryptedData, "verification-gigz");
          navigate("/auth/verify-account");
        } else {
          makeErrorToast({ message: response?.msg || "" });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center">
      <h2 className="text-2xl font-bold mb-2 mr-auto">Sign In To GIGZ</h2>

      <form className="w-full" onSubmit={submitHandler}>
        <div className="w-full flex flex-col gap-4 mb-4">
          <Input
            type="number"
            label="Mobile"
            value={data.phone}
            setValue={(val) => {
              setData((prev) => ({ ...prev, phone: val }));
            }}
            error={error.phone}
            setError={() => {
              setError((prev) => ({ ...prev, phone: "" }));
            }}
          />
          <Input
            type="password"
            label="Password"
            value={data.password}
            setValue={(val) => {
              setData((prev) => ({ ...prev, password: val }));
            }}
            error={error.password}
            setError={() => {
              setError((prev) => ({ ...prev, password: "" }));
            }}
          />
        </div>

        <button
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
          onClick={submitHandler}
        >
          Sign In
        </button>
      </form>
    </div>
  );
};

export default SignIn;
